module.exports = __webpack_public_path__ + "static/img/IMG_20150307_171358.c5235418.jpg";